/**
 * Tools
 * @class google.Tools
 * @memberof google
 */
export class Tools {
    static decodeFormatSize(value) {
        let result = value;
        if (Number.isNaN(Number(value))) {
            let patternPercent = /%/gi;
            let patternPixel = /px/gi;
            if (result.search(patternPixel) >= 0) {
                result = result.replace('px', '');
                if (!Number.isNaN(Number(result))) {
                    result = Number(result);
                }
            }
            else if (result.search(patternPercent) >= 0) {
                // do nothing
            }
        }
        return result;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVG9vbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZ29vZ2xlL1Rvb2xzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7O0dBSUc7QUFDSCxNQUFNLE9BQU8sS0FBSztJQUNQLE1BQU0sQ0FBQyxnQkFBZ0IsQ0FBRSxLQUFVO1FBQ3RDLElBQUksTUFBTSxHQUFHLEtBQUssQ0FBQTtRQUNsQixJQUFJLE1BQU0sQ0FBQyxLQUFLLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDLEVBQUU7WUFDN0IsSUFBSSxjQUFjLEdBQUcsS0FBSyxDQUFBO1lBQzFCLElBQUksWUFBWSxHQUFHLE1BQU0sQ0FBQTtZQUV6QixJQUFJLE1BQU0sQ0FBQyxNQUFNLENBQUMsWUFBWSxDQUFDLElBQUksQ0FBQyxFQUFFO2dCQUNsQyxNQUFNLEdBQUcsTUFBTSxDQUFDLE9BQU8sQ0FBQyxJQUFJLEVBQUUsRUFBRSxDQUFDLENBQUE7Z0JBQ2pDLElBQUksQ0FBRSxNQUFNLENBQUMsS0FBSyxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBQyxFQUFFO29CQUNoQyxNQUFNLEdBQUcsTUFBTSxDQUFDLE1BQU0sQ0FBQyxDQUFBO2lCQUMxQjthQUNKO2lCQUFNLElBQUksTUFBTSxDQUFDLE1BQU0sQ0FBQyxjQUFjLENBQUMsSUFBSSxDQUFDLEVBQUU7Z0JBQzNDLGFBQWE7YUFDaEI7U0FDSjtRQUNELE9BQU8sTUFBTSxDQUFBO0lBQ2pCLENBQUM7Q0FDSiJ9